<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none">
    <circle r="3" cx="12" cy="3" fill="currentColor" />
    <circle r="3" cx="12" cy="12" fill="currentColor" />
    <circle r="3" cx="12" cy="21" fill="currentColor" />
  </svg>
</template>
